import { Col, Popconfirm, Row } from 'antd';
import i18n from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../utilz/i18n';
import { ReactComponent as DeleteIcon } from './../../../assets/icons/delete-icon.svg';
import { ReactComponent as PencilIcon } from './../../../assets/icons/pencil-white.svg';
import Button from './../../components/Buttons/Button';
import IconButton from './../../components/Buttons/IconButton';
import SvgConverter from './../../components/Common/SvgConverter';

const SaveCancelButton = ({
  lightMode,
  editMode = true,
  disabled = false,
  onCancel = () => {},
  handleRemove = () => {},
  setEditMode = () => {},
  onSave,
  hideDeleteButton = false,
  isNew = false,
  cancelButtonText = i18n.t('translation:default.buttons.cancel'),
  buttonType = 'submit',
  hideEditIcon = false,
  isColumn = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  return (
    <>
      {editMode ? (
        <Row gutter={16} className={isColumn ? 'd-flex gap-half' : ''}>
          <Col>
            <Button
              type="primary"
              variant="success"
              buttonType={buttonType}
              lightMode={lightMode}
              {...(onSave ? { onClick: onSave } : {})}
            >
              {isNew ? t('translation:default.buttons.add') : t('translation:default.buttons.save')}
            </Button>
          </Col>
          <Col>
            <Button type="default" variant="danger" buttonType="button" lightMode={lightMode} onClick={onCancel}>
              {cancelButtonText}
            </Button>
          </Col>
        </Row>
      ) : (
        <Row>
          {!hideEditIcon && (
            <Col className={`${!hideDeleteButton ? 'mr-16' : ''} lh-0`}>
              <IconButton onClick={() => setEditMode(true)} disabled={disabled}>
                <SvgConverter disabled={disabled} Icon={PencilIcon} color="header" />
              </IconButton>
            </Col>
          )}

          {!hideDeleteButton && (
            <Col className="lh-0">
              <IconButton disabled={disabled}>
                <Popconfirm
                  placement="topRight"
                  title="Are you sure to delete?"
                  onConfirm={() => handleRemove()}
                  okText="Yes"
                  cancelText="Cancel"
                  overlayClassName=""
                >
                  <SvgConverter disabled={disabled} Icon={DeleteIcon} color="iconDanger" />
                </Popconfirm>
              </IconButton>
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default SaveCancelButton;
